import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p432090920587911168',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
